import angular from 'angular';

import RwListItemComponent from './rw-list-item-component';

export default angular
  .module('rw-list-item', [])
  .component('rwListItem', new RwListItemComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-list/components/rw-list-item-module.js